import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components' // Assuming components are three levels up
import { ClinicsTrainingModulePlaceholderImage } from 'assets'

// TODO: Import images from assets if any

interface TrainingModule {
  title: string
  link: string
  state?: { from: string }
  altText: string
}

export const ClinicsTrainingPage: React.FC = () => {
  const trainingModules: TrainingModule[] = [
    {
      title: 'Cultural Competency Training',
      link: '/toolkit/shared/cultural-competency-training',
      state: { from: 'clinics' },
      // Note: The original JSON for Clinics training used one placeholder image for all.
      // These deeper pages are within the providers section.
      altText: 'Cultural Competency Training module visual cue'
    },
    {
      title: 'Social Determinants of Health Training',
      link: '/toolkit/shared/social-determinants-health-training',
      state: { from: 'clinics' },
      altText: 'Social Determinants of Health Training module visual cue'
    },
    {
      title: 'Pain Management Strategies Training',
      link: '/toolkit/shared/pain-management-training',
      state: { from: 'clinics' },
      altText: 'Pain Management Strategies Training module visual cue'
    },
    {
      title: 'Sickle Cell Disease Modifying Treatments',
      link: '/toolkit/shared/scd-modifying-treatments',
      state: { from: 'clinics' },
      altText: 'Sickle Cell Disease Modifying Treatments module visual cue'
    }
  ]

  return (
    <ToolkitPageLayout
      title="Sickle Cell Disease Training (Clinics)"
      breadcrumbs={[
        { label: 'Toolkit', path: '/toolkit' },
        { label: 'Clinics', path: '/toolkit/clinics' },
        { label: 'Training Modules', path: '/toolkit/clinics/training' }
      ]}
    >
      <div className="space-y-10">
        <div className="prose max-w-none mb-8 text-[#3C2416]">
          <p className="text-xl">
            This section provides links to essential training modules relevant
            for clinic staff and operations. These modules cover key areas in
            Sickle Cell Disease care.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {trainingModules.map((module) => (
            <div
              key={module.title}
              className="flex flex-col items-center text-center p-4 border border-gray-200 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 bg-white"
            >
              <img
                src={ClinicsTrainingModulePlaceholderImage} // Using the single placeholder for all clinic training links
                alt={module.altText}
                className="mb-4 rounded-lg shadow-md h-48 w-full object-contain"
              />
              <Link
                to={module.link}
                state={module.state}
                className="text-xl font-semibold text-[#A6410A] hover:text-[#894d35]"
              >
                {module.title}
              </Link>
            </div>
          ))}
        </div>

        <hr className="my-12" />

        <div className="mt-12 mb-8 text-center">
          <Link
            to="/toolkit/clinics"
            className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-6 py-3 text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
          >
            All done? Click here to return to the Clinics screen
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
